import type { FC } from "react";
import { Fragment, useEffect } from "react";

import type { UserAssignmentDetailFragment } from "api/generated";

import { useAppSelector } from "store/hooks";
import { getAllResults } from "store/slices/topicPractice";

import { AnimatedCapybaraResult } from "components";
import { getAssignmentTutoringByType } from "utils/getAssignmentByType";

interface Props {
  activeAssignment?: UserAssignmentDetailFragment;
  changeAssignment: () => void;
}

const Practice: FC<Props> = ({ activeAssignment, changeAssignment }) => {
  const results = useAppSelector(getAllResults);

  useEffect(() => {
    changeAssignment();
  }, []);

  const goNextAssignment = () => {
    changeAssignment();
  };

  return (
    <div className="exercise full-page">
      {activeAssignment?.id !== undefined && results[activeAssignment?.id]?.status === "correct" && (
        <AnimatedCapybaraResult />
      )}

      {activeAssignment === undefined ? (
        <div>Nastala chyba při zobrazování úlohy</div>
      ) : (
        <Fragment key={activeAssignment.id}>
          {getAssignmentTutoringByType(
            activeAssignment.assignment?.assignment?.assignmentType.type,
            activeAssignment,
            goNextAssignment,
          )}
        </Fragment>
      )}
    </div>
  );
};

export default Practice;
